// Components
import Content from './Content';
import ContentSession from '../../molecules/ContentSession/ContentSession';

// Styles
import styles from './Content.module.css';

// Data
import sessions from '../../../assets/data/sessions.json';

/**
 * @function ContentRegularSessions
 * Describe the component's function
 *
 * @example
 * return (
 *   <ContentRegularSessions />
 * )
 */
function ContentRegularSessions(): JSX.Element {
    const regularSessions = sessions.filter(
        ({ category }) => category === 'regular',
    );

    return (
        <Content>
            <h3 className={styles.heading}>Regular sessions</h3>
            <p>There are 9 regular bingo sessions.</p>
            <p>
                All sessions subject to change or cancellation without notice.
                Please review the session information in the lobby carefully
                before entering.
            </p>
            <p>
                These sessions provide free online bingo entertainment, 24 hours
                a day, 7 days a week. Use the Port Points you win in the regular
                sessions to redeem a Session Access Token and play in the
                Featured Sessions where you can win enough Port Points to cash
                in real prizes, like Amazon Vouchers and cash via PayPal.
            </p>
            <div className={styles.grid}>
                {regularSessions.map(
                    (
                        {
                            id,
                            title,
                            room,
                            frequency,
                            days,
                            time,
                            games,
                            cards,
                            daubing,
                            fee,
                            prizes,
                            restrictions,
                        },
                        index,
                    ) => (
                        <div className={styles.item}>
                            <ContentSession
                                key={id}
                                index={index}
                                title={title}
                                room={room}
                                frequency={frequency}
                                days={days}
                                time={time}
                                games={games}
                                cards={cards}
                                daubing={daubing}
                                fee={fee}
                                prizes={prizes}
                                restrictions={restrictions}
                            />
                        </div>
                    ),
                )}
            </div>
        </Content>
    );
}

// Exports
export default ContentRegularSessions;
